import apiService from "../../../../services/api";

export const getIdentityVerifyStatus = async () => {
  return await apiService.get(`candidate/identity-verify-status`);
};
export const verifyIdentity = async (successUrl: string) => {
  return await apiService.post(`webhooks/stripe/create_identity_session?success_url=${encodeURIComponent(successUrl)}`);
};
export const getStripePayment = async (successUrl:string,cancleUrl:string) => {
  return await apiService.post(`webhooks/stripe/create-id-verify-payment?success_url=${successUrl}&cancel_url=${cancleUrl}`);
};
//http://18.188.73.145:8000/api/v1/webhooks/stripe/create-id-verify-payment?success_url=nn&cancel_url=nn

